var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.650024 3.9C0.650024 1.5 2.75002 0 5.00002 0C7.05002 0 9.35003 1.4 9.35003 3.65C9.35003 5.1 8.65002 6.1 7.50002 6.9C7.10002 7.2 6.65002 7.55 6.30002 7.9C5.95002 8.35 5.70002 8.9 5.70002 9.6H3.75002C3.70002 9.35 3.65002 9 3.65002 8.8C3.65002 5.95 7.10002 5.7 7.10002 3.7C7.10002 2.6 6.00002 1.95 5.05002 1.95C3.80002 1.95 2.85002 2.95 2.85002 4.2C2.85002 4.4 2.85002 4.55 2.90002 4.7L0.700024 4.6C0.650024 4.4 0.650024 4.15 0.650024 3.9ZM4.75002 14C5.50002 14 6.15002 13.4 6.15002 12.65C6.15002 11.9 5.50002 11.25 4.75002 11.25C4.00002 11.25 3.40002 11.85 3.40002 12.65C3.40002 13.45 4.00002 14 4.75002 14Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.9247721b4468a8ec4b71b8720fb81ed5.svg";
export { ForwardRef as ReactComponent };